import React from "react";

const ProductDetails = (props) => {
  const {product} = props;

  return <div className="product-details">
    <p className="product-description" dangerouslySetInnerHTML={{__html: product?.description}}/>
  </div>;
};

export default ProductDetails;
